<template>
  <div>
    <div id="main-wrapper" class="show">
      <!-- Header -->
      <Header :active="active" />
      <!-- Page Title -->
      <page-title v-if="title" />
      <!-- Content -->
      <div class="homepage mb-80" v-if="!fulid">
        <div class="container">
          <slot v-if="!setting" />
          <div class="row" v-else>
            <div class="col-xl-3 col-md-4">
              <setting-layout :activeSetting="activeSetting" />
            </div>
            <div class="col-xl-9 col-md-8">
              <slot />
            </div>
          </div>
        </div>
      </div>
      <slot v-else />
      <Footer />
    </div>
    <div class="bg_icons" v-if="fulid"></div>
  </div>
</template>

<script>
import PageTitle from "../dashboards/PageTitle";
import Header from "../dashboards/Header.vue";
import SettingLayout from "../dashboards/SettingSideBar";
import Footer from "../Footer.vue";
export default {
  components: { Header, PageTitle, SettingLayout, Footer },
  name: "DashBoardLayout",
  props: {
    active: Number,
    title: Boolean,
    fulid: Boolean,
    setting: Boolean,
    activeSetting: Number,
  },
  mounted() {
    document.querySelector("body").className = "dashboard";
  },
};
</script>
